import { Getter } from '@zajno/common/types/getter';

export type DomElementState = {
    // haha, no
    [x: string]: any;
};

export type ComputedValues<TKey extends string = string, T = number> = {
    [K in TKey]: Getter<T> | ComputedValues.UnresolvedType;
};

export namespace ComputedValues {
    export const UnresolvedKey = 'Unresolved!' as const;
    export type UnresolvedType = typeof UnresolvedKey;

    export function parseComputed(computed: ComputedValues, v: number | string): { map: ComputedValues, value: number } {
        const result = {
            map: computed,
            value: 0,
        };

        if (typeof v === 'string') {
            if (!computed) {
                result.map = computed = { } as any;
            } else {
                const cv = computed[v];
                if (cv !== UnresolvedKey) {
                    const vv = Getter.getValue(cv);
                    if (vv != null && !Number.isNaN(vv)) {
                        result.value = vv;
                        return result;
                    }
                }
            }

            computed[v] = UnresolvedKey;
        } else {
            result.value = v;
        }

        return result;
    }
}
